import G2 from '@clearkit/icons/services/G2';

import LogoIcon from './Clearbit.svg';
import HubspotIcon from './Hubspot.svg';
import PageViewIcon from './Pageview.svg';
import SalesforceIcon from './Salesforce.svg';
import TraitIcon from './Trait.svg';

const iconForCategory = (categoryName, props) => {
  props.style = {
    ...props.style,
    maxWidth: 16,
    maxHeight: 16,
  };

  switch (categoryName) {
    case 'salesforce':
      return <SalesforceIcon {...props} />;
    case 'clearbit':
      return <LogoIcon {...props} />;
    case 'traits':
      return <TraitIcon {...props} />;
    case 'hubspot':
      return <HubspotIcon {...props} />;
    case 'page view':
    case 'page_views':
      return <PageViewIcon {...props} />;
    case 'g2':
      return <G2 {...props} />;
    default:
      return null;
  }
};

iconForCategory.propTypes = {
  style: PropTypes.object,
};

export default iconForCategory;
